export default __webpack_public_path__ + "static/media/FactoryIconEdit.917078ba.svg";